"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { GraduationCap, Heart, TrendingUp } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function TheRealReasonsStudentsFallBehind() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const handleScrollToTestimonials = () => {
    const testimonialsSection = document.getElementById("testimonials");
    if (testimonialsSection) {
      testimonialsSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };
  const columns = [{
    icon: GraduationCap,
    title: "Academic Excellence",
    content: "Students across KS3 and GCSE levels consistently achieve grade improvements in Science, Maths, and English. Our personalised approach identifies exact knowledge gaps and fills them systematically, while building deep understanding rather than surface-level memorisation. Every session focuses on mastery, not just completion."
  }, {
    icon: Heart,
    title: "Confidence Transformation",
    content: "We've seen anxious students walk into exam halls with calm focus. Our integrated confidence coaching tackles exam stress, builds resilience, and teaches students how to manage pressure. They don't just learn content, they learn to trust their abilities and perform when it matters most."
  }, {
    icon: TrendingUp,
    title: "Skills for Life",
    content: "The study habits, time management, and learning strategies students develop with us extend far beyond exams. Parents consistently tell us their children become more independent, motivated, and equipped for university and career success. We're not just preparing students for tests—we're preparing them for life."
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-light-background">
      <div className="max-w-6xl mx-auto">
        <div ref={headingRef} className={`text-center mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-primary mb-4">
            Proven Results That Build Futures
          </h2>
          <p className="text-lg sm:text-xl text-foreground max-w-4xl mx-auto leading-relaxed">The majority of our students improve by at least one grade level within three months, while developing the confidence and study skills that last a lifetime.</p>
        </div>

        <div ref={contentRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {columns.map((column, i) => {
          const Icon = column.icon;
          return <div key={i} data-index={i} className="card bg-white p-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
            transitionDelay: `${(i + 2) * 100}ms`
          }}>
                <div className="flex items-center justify-center size-12 bg-secondary/10 rounded-lg mb-4">
                  <Icon className="size-6 text-secondary" aria-hidden="true" />
                </div>
                <h3 className="text-xl font-display font-semibold text-primary mb-3">
                  {column.title}
                </h3>
                <p className="text-foreground leading-relaxed">
                  {column.content}
                </p>
              </div>;
        })}
        </div>

        <div ref={ctaRef} className={`text-center p-8 bg-secondary-light rounded-lg shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="text-lg sm:text-xl text-foreground font-semibold mb-6">
            See how we can transform your child's academic journey
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/ContactPage">
              <button className="btn-primary">Book Free Consultation</button>
            </Link>
            
          </div>
        </div>
      </div>
    </section>;
}